import { OfferTypeEnum } from "./offerType";

class OfferTypeHelper {

    public isCash(offerType: OfferTypeEnum): boolean {
        return offerType === OfferTypeEnum.Cash || offerType === OfferTypeEnum.CashMinPrice;
    }

    public isHta(offerType: OfferTypeEnum): boolean {
        return offerType === OfferTypeEnum.Hta || offerType === OfferTypeEnum.HtaMinPrice;
    }

    public isBasis(offerType: OfferTypeEnum): boolean {
        return [OfferTypeEnum.BasisContract, OfferTypeEnum.BasisOffer].includes(offerType);
    }

    public isPriceLockAllowed(offerType: OfferTypeEnum): boolean {
        return [OfferTypeEnum.Cash, OfferTypeEnum.Hta, OfferTypeEnum.CashMinPrice, OfferTypeEnum.HtaMinPrice, OfferTypeEnum.FixFuturesOnBasis].includes(offerType);
    }

    public hasFuturesPrice(offerType: OfferTypeEnum): boolean {
        return [OfferTypeEnum.BushelOnlyContract, OfferTypeEnum.Cash, OfferTypeEnum.Hta, OfferTypeEnum.CashMinPrice, OfferTypeEnum.HtaMinPrice, OfferTypeEnum.FixFuturesOnBasis].includes(offerType);
    }

    public hasBasis(offerType: OfferTypeEnum): boolean {
        return [OfferTypeEnum.BushelOnlyContract, OfferTypeEnum.Cash, OfferTypeEnum.CashMinPrice, OfferTypeEnum.BasisContract, OfferTypeEnum.BasisOffer].includes(offerType);
    }

    public originatesFromOffer(offerType: OfferTypeEnum): boolean {
        return [OfferTypeEnum.Cash, OfferTypeEnum.Hta, OfferTypeEnum.BasisOffer, OfferTypeEnum.CashMinPrice, OfferTypeEnum.HtaMinPrice, OfferTypeEnum.FixFuturesOnBasis, OfferTypeEnum.FixBasisOnHta].includes(offerType);
    }

    public canHaveDelayedPriceContract(offerType: OfferTypeEnum): boolean {
        return [OfferTypeEnum.Cash, OfferTypeEnum.Hta, OfferTypeEnum.CashMinPrice, OfferTypeEnum.HtaMinPrice, OfferTypeEnum.BasisContract, OfferTypeEnum.BasisOffer].includes(offerType);
    }

    public canBeHedged(offerType: OfferTypeEnum): boolean {
        return ![OfferTypeEnum.DelayedPriceContract, OfferTypeEnum.BasisContract, OfferTypeEnum.BasisOffer, OfferTypeEnum.FixBasisOnHta, OfferTypeEnum.BushelOnlyContract].includes(offerType);
    }

    public canBuyNow(offerType: OfferTypeEnum): boolean {
        return [OfferTypeEnum.Cash, OfferTypeEnum.CashMinPrice, OfferTypeEnum.Hta, OfferTypeEnum.HtaMinPrice].includes(offerType);
    }
}

const offerTypeHelper = new OfferTypeHelper()

export default offerTypeHelper;